<template>
    <v-container>
        <v-card>
            <v-card-title class="yellow"><span class="white--text">Please Login</span></v-card-title>
            <v-card-text>
                <v-alert class="mt-3" dense outlined type="error" v-if="loginError" >
                    {{loginError}}
                </v-alert>
                <v-form
                        lazy-validation
                        ref="form"
                        v-model="valid"
                >
                    <v-text-field
                            :rules="usernameRules"
                            label="Username"
                            required
                            v-model="username"
                            id="username"
                            @keydown="loginKey"
                    ></v-text-field>

                    <v-text-field
                            :rules="passwordRules"
                            label="Password"
                            required
                            type="password"
                            v-model="password"
                            @keydown="loginKey"
                    ></v-text-field>

                    <v-btn
                            :disabled="!valid"
                            @click="login"
                            class="mr-4 white--text"
                            color="green"
                    >
                        Login
                    </v-btn>
                    <div class="mt-2">
                        <a class="mr-2" style="font-size:12px;" @click="showForgotPasswordDialog">Forgot your password?</a> ·
                        <a class="mr-2" style="font-size:12px;" @click="showForgotUsernameDialog">Forgot your username?</a>
                    </div>
                </v-form>
            </v-card-text>
        </v-card>
        <v-dialog max-width="290" persistent v-model="errorDialog">
            <v-card>
                <v-card-title class="error white--text">Error</v-card-title>
                <v-card-text>{{errorText}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="errorDialog = false" color="green darken-1" text>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="490" persistent v-model="forgotDialog">
            <v-card>
                <v-card-title v-if="isForgotPassword" class="yellow white--text">Password Reset</v-card-title>
                <v-card-title v-if="isForgotUsername" class="yellow white--text">Retrieve Username</v-card-title>
                <v-container v-if="forgotInput">
                    <v-card-text>
                        <v-form
                                ref="forgotForm"
                                v-model="forgotFormValid"
                        >
                            <div class="mb-2">Email</div>
                            <v-text-field
                                    :rules="forgotEmailRules"
                                    outlined
                                    placeholder="Please enter your email"
                                    required
                                    v-model="forgotEmail"
                                    id="forgot-email"
                                    @keydown="forgotKey"
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="!forgotFormValid"
                            @click="submit"
                            color="green darken-1"
                            text>
                        Submit
                        </v-btn>
                        <v-btn
                            @click="forgotDialog = false"
                            color="orange darken-1"
                            text>
                        Close
                        </v-btn>
                    </v-card-actions>
                </v-container>
                <v-container v-if="forgotMessage">
                    <v-card-text v-if="isForgotPassword">
                        If you are registered in our system we have sent you an email with instructions to setup/reset your password. Please contact support should you not receive an email.
                    </v-card-text>
                    <v-card-text v-if="isForgotUsername">
                        If you are registered in our system we have sent you an email with your username. Please contact support should you not receive an email.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click="forgotDialog = false"
                            color="orange darken-1"
                            text>
                        Close
                        </v-btn>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import api from "../services/aggrega8-api";

    export default {
        name: 'login',

        computed: {
            apiKey: function () {
                return this.$store.state.apiKey
            },
            userDetails: function () {
                return this.$store.state.userDetails
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            },
            selectedProgram: function () {
                return this.$store.state.selectedProgram
            },
        },

        data: () => ({
            errorDialog: false,
            errorText: "",
            valid: false,
            username: '',
            usernameRules: [
                v => !!v || 'Username is required'
            ],            
            forgotDialog: false,
            forgotEmail: "",
            forgotFormValid: false,
            forgotInput: true,
            forgotMessage: false,
            isForgotPassword: false,
            isForgotUsername: false,
            email: '',
            emailRules: [
                v => !!v || 'Email is required'
            ],
            forgotEmailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            password: '',
            passwordRules: [
                v => !!v || 'Password is required',
            ],
            loginError: ""
        }),

        mounted() {
            let el = document.getElementById("username")
            if (el) el.focus()
        },
        methods: {
            loginKey(k) {
                if (k.keyCode == 13) this.login()
            },
            forgotKey(k) {
                if (k.keyCode == 13) this.submit()
            },
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                }
            },
            login() {
                this.$store.dispatch("setExecuting", true)
                api.post("/login", {username: this.username, password: this.password}).then(
                (results) => {
                    this.$store.dispatch("setApiKey", results.data.access_token)
                    this.$router.push("/")
                },
                (error) => {
                    console.log(error.response.status)
                    if (error.response.status == 401 || error.response.status == 403) this.errorText = "Invalid Login"
                    else this.errorText = error.response.data
                    this.errorDialog = true
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            },
            resetForgotDialog()
            {
                this.forgotInput = true
                this.forgotMessage = !this.forgotInput
                this.forgotEmail = ""
                this.forgotFormValid = false
                this.forgotDialog = true
            },
            showForgotPasswordDialog()
            {
                this.resetForgotDialog()
                this.isForgotPassword = true
                this.isForgotUsername = !this.isForgotPassword
            },
            showForgotUsernameDialog()
            {
                this.resetForgotDialog()
                this.isForgotUsername = true
                this.isForgotPassword = !this.isForgotUsername
            },
            forgotPasswordOrUsername()
            {
                return this.isForgotPassword ?
                    api.post("/public/forgotpassword", {user: this.forgotEmail}) :
                    api.post("/public/forgotusername", {email: this.forgotEmail})
            },
            submit() {
                this.$store.dispatch("setExecuting", true)

                this.forgotPasswordOrUsername()
                .then(
                () => {
                    this.forgotInput = false
                    this.forgotMessage = !this.forgotInput
                },
                (error) => {
                    console.log(error.response.status)
                    this.errorText = error.response.data
                    this.errorDialog = true
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            }
        },
    }
</script>
